module.exports = "<select class=\"form-control\" [class.loading]=\"loading\" [formControl]=\"control\" [multiple]=\"multiple\">\r\n\t<ng-content></ng-content>\r\n\t<option *ngFor=\"let v of values\" [value]=\"v.value\">{{v.name}}</option>\r\n</select>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-select.component.html
// module id = 428
// module chunks = 11